/*科技成果*/
let prjConfig = {
   portalType: '19'
};
export default prjConfig